import { Injectable } from '@angular/core'
import { Store } from '@ngxs/store'
import { Observable } from 'rxjs'
import { FeatureFlagKeyOfType, LaunchDarklyFlagValue, WebFeatureFlags } from '../feature-flags'
import { FeatureFlagState } from '../store'

@Injectable()
export class LaunchDarklyService {
  constructor(private readonly store: Store) {}

  observeFlagChanges<T extends LaunchDarklyFlagValue>(key: FeatureFlagKeyOfType<T>): Observable<T> {
    return this.store.select(FeatureFlagState.featureFlag(key))
  }

  getFlagMap(): Observable<WebFeatureFlags> {
    return this.store.select(FeatureFlagState.allFeatureFlags)
  }
}
